import React from 'react';

interface ShoulderRelaxedProps {}

export function ShoulderRelaxed(props: Readonly<ShoulderRelaxedProps>) {
	return (
		<svg width={90} height={88} viewBox="0 0 90 88" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<g clipPath="url(#clip0_2182_11500)">
				<path
					fill="#71828F"
					fillRule="evenodd"
					clipRule="evenodd"
					d="M29.198 97.239v-3.791H18.81V81.981H14.63v13.38c0 1.032.932 1.878 2.071 1.878h12.498z"
				/>
				<path
					fill="#505A63"
					fillRule="evenodd"
					clipRule="evenodd"
					d="M13.713 67.43h6.453c.838 0 1.47.818 1.523 1.81l.705 13.007c0 .984-.687 1.81-1.523 1.81h-7.76c-.836 0-1.569-.816-1.523-1.81l.604-13.007c.044-.994.683-1.81 1.521-1.81z"
				/>
				<path
					fill="#71828F"
					fillRule="evenodd"
					clipRule="evenodd"
					d="M61.875 97.239v-3.791h10.388V81.981h4.181v13.38c0 1.032-.932 1.878-2.07 1.878H61.874z"
				/>
				<mask
					id="a"
					x={68}
					y={67}
					width={12}
					height={18}
					maskUnits="userSpaceOnUse"
					style={{ maskType: 'luminance' }}
				>
					<path d="M68.734 67.43H79.69v16.627H68.734V67.43z" fill="#fff" />
				</mask>
				<g mask="url(#a)">
					<path
						fill="#505A63"
						fillRule="evenodd"
						clipRule="evenodd"
						d="M77.532 67.457H71.12c-.833 0-1.461.811-1.514 1.795l-.7 12.901c-.052.983.683 1.796 1.515 1.796h7.712c.831 0 1.544-1.244 1.498-2.23l-.585-12.467c-.045-.986-.68-1.795-1.513-1.795z"
					/>
				</g>
				<path
					fill="#282626"
					fillRule="evenodd"
					clipRule="evenodd"
					d="M40.262 93.892V84.06h10.015v9.834H40.262z"
				/>
				<path
					fill="#373D4A"
					fillRule="evenodd"
					clipRule="evenodd"
					d="M42.125 79.012h10.014v5.387H42.124v-5.387z"
				/>
				<mask
					id="b"
					x={23}
					y={25}
					width={45}
					height={64}
					maskUnits="userSpaceOnUse"
					style={{ maskType: 'luminance' }}
				>
					<path d="M23.008 25.863h44.27V88.13h-44.27V25.863z" fill="#fff" />
				</mask>
				<g mask="url(#b)">
					<path
						fill="#505A63"
						fillRule="evenodd"
						clipRule="evenodd"
						d="M32.697 25.863h25.997c2.667 0 4.55 1.343 4.848 5.89l3.308 50.413c.298 4.548-2.186 5.891-4.849 5.891h-32.61c-2.665 0-5.149-1.336-4.851-5.89l3.308-50.415c.299-4.555 2.182-5.889 4.849-5.889z"
					/>
				</g>
				<path
					fill="#3E454A"
					fillRule="evenodd"
					clipRule="evenodd"
					d="M67.073 84.059c-.101 3.185-2.424 4.156-4.9 4.156H29.366c-2.478 0-4.8-.966-4.901-4.156h42.608zM22.304 81.98c0 1.868-.463 2.079-2.541 2.079h-6.235c-.626 0-2.079 0-1.94-2.078h10.716zM79.667 81.98c0 1.868-.462 2.079-2.54 2.079H70.89c-.626 0-2.079 0-1.94-2.078h10.716z"
				/>
				<path
					fill="#999"
					d="M64.402 52.604c.366-.467 1.708-2.533 2.132-3.248.425-.715.958-1.584 1.364-2.417.44-.9 1.212-2.402 1.766-3.496.473-.932 2.22-4.422-.45-7.566-1.36-1.175-2.683-1.555-5.593-2.212-4.15-.936-4.283-.47-8.275-2.032-1.883-.738-2.827-1.787-3.74-3.356-.317-.546.042-2.999 0-3.513-.038-.463-.496-.827-1.062-.827l-11.047-.015c-.575 0-1.059.371-1.072.842-.021.695.327 2.923 0 3.513-.49 1.303-2.086 2.59-4.38 3.356-2.279.858-3.337 1.065-7.229 2.136-1.35.372-3.267.979-4.308 1.762-.793.598-1.511 1.831-1.738 2.626-.227.795-.24 2.718.491 4.63.732 1.912 1.748 3.533 1.911 4 .163.467 1.139 2.572 1.464 3.172.325.6 1.235 2.171 1.382 2.36.147.187.854 1.265 1.138 1.732.163.3.667 1.237.813 1.532.3.602 2.11 4.569 2.314 6.035.293 2.11 1.068 6.426 1.068 8.948-.34 4.008-.331 10.206-2.107 18.69-.2.958-.146 2.104 0 3.437.403 3.683 2.953 8.914 17.1 8.914 14.148 0 16.279-7.748 16.425-8.914.145-1.166.18-2.004 0-3.436-.181-1.433-2.171-14.19-2.473-18.69-.132-1.958 0-6.945.302-8.95.336-2.228 1.624-5.442 2.799-7.45.233-.397.64-1.097 1.005-1.563z"
				/>
				<path
					fill="#7F7F7F"
					d="M39.539 4.277C40.585 3.66 43.056 3 44.569 3c1.512 0 3.804.115 5.676 1.277C52.117 5.44 52.802 6.3 53.23 7.01c.43.71 1.374 2.815 1.735 4.564.395 1.915.244 3.41.166 4.056-.202 1.655-1.093 4.481-1.854 5.841-.761 1.36-3.032 5.499-4.146 6.823-1.114 1.325-2.033 1.727-4.369 1.727-2.067 0-3.398-1.207-4.31-2.2-.913-.993-3.478-5.345-3.823-5.912-.345-.568-1.804-3.43-2.033-5.333-.23-1.904-.18-3.83 0-5.002.18-1.172.934-3.18 1.832-4.564.897-1.384 2.065-2.114 3.111-2.732zM71.298 68.748a4.673 4.673 0 001.557.938 3.782 3.782 0 001.68.204 3.486 3.486 0 001.546-.563c.467-.31.867-.732 1.177-1.243.476-.78.801-2.116.74-2.741-.04-.407-.101-.968-.184-1.485-.157-1.019-.351-1.57-.675-2.555-.655-1.98-.563-1.538-1.186-3.248-.543-2.161-1.103-3.924-1.835-8.073a60.072 60.072 0 00-1.957-7.958c-.219-.637-.428-1.236-.608-1.782l-.016-.066c-.29-.761-.55-1.469-.76-2.008a7.662 7.662 0 00-1.715-2.286 6.835 6.835 0 00-2.287-1.37 5.53 5.53 0 00-2.465-.288c-.812.095-1.597.274-2.265.839a4.883 4.883 0 00-1.17 1.691c-.22.516-1.023 1.828-.923 4.993.026.833.216 1.716.268 1.932.05.216-.05-.2 0 0 .544 2.294 1.286 4.336 2.215 6.424.937 2.106 1.856 3.594 1.856 3.594.862 1.566 1.065 1.804 1.774 3.23.647 1.3 1.354 2.94 1.955 4.36.481 1.449 1.294 3.475 1.492 4.053.325.953.464 1.546.771 2.131.307.585.55.852 1.015 1.277z"
				/>
				<path
					fill="#999"
					d="M76.746 84.959c-.108.099-2.055 2.074-3.027 1.969-1.073-.392-1.262-1.145-1.256-1.437.008-.453 1.432-3.433 1.469-4.557.044-1.37-.42-2.486-1.072-3.468 0 0-.325.86-.972 1.535-.553.577-.38 2.056-1.236 2.022-.855-.035-.886-2.162-.847-2.823.05-.827.183-1.843.288-2.308.105-.465.393-1.118.701-1.684.39-.712 1.064-1.725 1.179-1.865 0 0 .241-.371.796-.552 0 0 .882-.126 1.53-.056.647.07 1.158.4 1.468.658.31.258 1.118 1.509 1.531 2.012.413.503.98 1.753.977 1.816 0 0 .33.727.703 1.804.12.618.82 1.488.82 1.488.383.501.415.862.415.862.124.664-.142 1.013-.701 1.347-.501.346-.896 1.378-1.366 1.772-.47.392-1.292 1.366-1.4 1.465z"
				/>
				<path
					fill="#999"
					d="M71.982 75.588c.445.184.866.253 1.448.25.582-.002.906-.045 1.184-.13.333-.102.736-.242 1.036-.518.374-.345.625-1.296.704-1.606.937-3.691.277-1.756 1.35-4.645.416-2.146.52-2.81.52-3.818 0-1.01-.683-1.713-1.075-2.02-.392-.307-1.047-.652-2.004-.707-1.238 0-1.71.059-2.712.412-.862.305-1.19.753-1.473 1.002-.34.3-.807 1.2-.884 1.592-.207 1.242-.08 1.483.268 2.737.304.995.308 1.513.594 2.52.261 1.122.354 1.88.377 2.457.019.479-.037 1.449.015 1.78.052.33.23.52.652.694zM13.563 84.955c.107.099 2.055 2.074 3.026 1.969 1.074-.392 1.263-1.145 1.257-1.437-.009-.453-1.433-3.433-1.47-4.557-.044-1.369.42-2.486 1.072-3.467 0 0 .326.86.973 1.535.553.576.38 2.055 1.235 2.02.856-.034.887-2.161.847-2.822-.049-.827-.182-1.843-.288-2.308-.105-.465-.392-1.118-.7-1.684-.39-.712-1.064-1.725-1.18-1.865 0 0-.24-.371-.795-.552 0 0-.883-.126-1.53-.056-.648.07-1.159.4-1.468.659-.31.257-1.118 1.508-1.531 2.01-.414.504-.98 1.754-.977 1.817 0 0-.33.727-.704 1.804-.12.618-.82 1.488-.82 1.488-.383.501-.415.862-.415.862-.124.664.142 1.014.702 1.347.5.346.896 1.379 1.365 1.772.47.392 1.293 1.366 1.4 1.465z"
				/>
				<path
					fill="#7F7F7F"
					d="M19.054 68.916a4.674 4.674 0 01-1.557.938 3.783 3.783 0 01-1.68.204 3.487 3.487 0 01-1.546-.563 3.914 3.914 0 01-1.178-1.243c-.476-.78-.8-2.116-.739-2.741.04-.407.1-.968.183-1.484.157-1.02.352-1.571.675-2.556.656-1.98.563-1.538 1.187-3.248.543-2.161 1.103-3.924 1.835-8.073a60.048 60.048 0 011.957-7.958c.218-.637.428-1.236.608-1.782l.016-.066c.289-.761.549-1.469.76-2.008a7.666 7.666 0 011.715-2.286 6.831 6.831 0 012.287-1.37 5.53 5.53 0 012.464-.288c.812.095 1.598.274 2.265.839a4.883 4.883 0 011.17 1.691c.22.516 1.024 1.827.924 4.993-.026.833-.217 1.716-.268 1.932-.051.216.05-.2 0 0-.545 2.294-1.286 4.336-2.215 6.424-.937 2.106-1.857 3.594-1.857 3.594-.862 1.566-1.064 1.804-1.774 3.23-.646 1.3-1.353 2.94-1.954 4.36-.482 1.449-1.295 3.475-1.492 4.053-.325.954-.465 1.546-.771 2.131-.307.585-.551.853-1.015 1.277z"
				/>
				<path
					fill="#999"
					d="M18.534 74.76c-.445.184-.866.253-1.448.25-.582-.002-.907-.045-1.185-.13-.332-.102-.735-.242-1.035-.518-.375-.346-.626-1.297-.704-1.606-.937-3.691-.278-1.756-1.35-4.645-.416-2.146-.521-2.81-.521-3.819s.683-1.712 1.075-2.02c.392-.306 1.048-.65 2.004-.706 1.238 0 1.71.058 2.712.412.863.305 1.19.753 1.474 1.002.34.3.807 1.2.884 1.592.206 1.242.08 1.483-.268 2.737-.304.995-.309 1.512-.594 2.52-.262 1.122-.354 1.879-.377 2.457-.02.479.037 1.449-.015 1.78-.052.33-.23.52-.652.694z"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2182_11500">
					<path fill="#fff" d="M0 0H90V88H0z" />
				</clipPath>
			</defs>
		</svg>
	);
}
